const Backbone = require('backbone');

module.exports = Backbone.Model.extend({
    defaults: {
        providerId: null,
        name: '',
        email: '',
        createdAt: null,
        updatedAt: null
    },

    getName: function() {
        return this.get('name');
    },

    getProviderId: function() {
        return this.get('providerId');
    },

    getProviderName: function() {
        return 'quadcept';
    }
});



// WEBPACK FOOTER //
// ./jiji/domain/entity/account/quadcept.js